import { BaseTable, Loading, TableHeader } from "components";
import { useListDataPost } from "../../utils";
import { DepositType } from "pages/Card/Transaction/CreateNewVendor/types";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";

export function Deposit(props: {
    dateFrom: string
    dateTo: string
    approval?: string
    vendorId: number,
}) {

    const { data, isLoading } = useListDataPost<DepositType>("deposit", {
        DateFrom: props.dateFrom,
        DateEnd: props.dateTo,
        Approval: props.approval,
        VendorID: props.vendorId
    })

    const totalDeposit = data.reduce((total, item) => total + item.amount, 0)

    return (
        <div>
            <div className="overflow-x-auto mt-12 max-h-[700px]">
                <BaseTable className="border-collapse">
                    <TableHeader>
                        <tr>
                            <th>NO</th>
                            <th>DEPOSIT ID</th>
                            <th>DATE</th>
                            <th>APPROVAL</th>
                            <th>MEMO</th>
                            <th>DEPOSIT</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {isLoading || !data.length ? (
                            <tr>
                                <td colSpan={6}>
                                    <div className="w-full flex justify-center items-center">
                                        <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index: number) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{item.transaction_date ? moment(item.transaction_date).format("DD/MM/YYYY") : ""}</td>
                                        <td>{APPROVAL[item.approve_status]}</td>
                                        <td>{item.memo}</td>
                                        <td>{item.amount ? convertNumber(item.amount).intoCurrency : ""}</td>
                                    </tr>
                                )
                            }
                            )
                        )}
                    </tbody>
                </BaseTable>
            </div>

            <div className="mt-2 flex justify-end font-bold">
                <div className="flex flex-col gap-2">
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Deposit</span>
                        <span>:</span>
                        <span className="text-right ml-2">{totalDeposit ? convertNumber(totalDeposit).intoCurrency : ""}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}